import React from 'react';
import _omit from 'lodash/omit';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import Typography, { TypographyProps } from 'components/Typography';
import { NOKIA_PURE_TEXT } from '@nokia-csf-uxr/freeform-design-tokens/tokens/fontFamily';

const DEFAULT_ERROR_MAX_LINES = 2;

const ERROR_TYPOGRAPHY_CONFIG = {
  role: 'alert',
  maxLines: DEFAULT_ERROR_MAX_LINES,
};

const ERROR_TYPOGRAPHY_STYLE = {
  fontFamily: NOKIA_PURE_TEXT,
  fontSize: '0.75rem',
  lineHeight: '0.938rem',
};

export interface TextAreaErrorMessageProps extends TypographyProps {
  /** The error message. */
  children: string;
}

/** Any other props than the `TextAreaErrorMessage` props will be provided to the <Typography /> component. */
const TextAreaErrorMessage = React.forwardRef<HTMLElement, TextAreaErrorMessageProps>((props: TextAreaErrorMessageProps, ref) => getContext(({ theme }) => {
  const {
    children,
    ...otherProps
  } = props;

  const COLOR_STYLE = {
    color: theme.TEXT_AREA.ERROR_MSG
  };
  const resolvedStyle = _merge({}, ERROR_TYPOGRAPHY_STYLE, COLOR_STYLE);

  return (
    <Typography ref={ref} style={resolvedStyle} {..._omit({ ...ERROR_TYPOGRAPHY_CONFIG, ...otherProps }, 'children')}>{children}</Typography>
  );
}));

TextAreaErrorMessage.displayName = 'TextAreaErrorMessage';

export default TextAreaErrorMessage;
